module.exports = __webpack_public_path__ + "img/icon-triangle-mobile.c76de95.svg";